export const filterDataProps = (props) => Object.fromEntries(Object.entries(props ?? {}).filter(([key]) => key?.startsWith?.('data-')));
export const filterDataFocusProp = (props) => Object.fromEntries(Object.entries(props ?? {}).filter(([_, value]) => value === 'focus'));
export const filterEventHandlerProps = (props) => Object.fromEntries(Object.entries(props ?? {}).filter(([key]) => key?.startsWith?.('on')));
const attachRef = (el, ref) => {
    if (typeof ref === 'function') {
        ref(el);
    }
    if (typeof ref === 'object' && ref !== null) {
        ref.current = el;
    }
};
export const combineRefs = (refs) => (el) => refs.forEach((ref) => attachRef(el, ref));
export const isSSR = () => typeof window === 'undefined';
export const queryMatchMedia = (query, { ssrFallbackValue, browserFallbackValue = ssrFallbackValue, }) => (isSSR() ? ssrFallbackValue : window.matchMedia?.(query)?.matches ?? browserFallbackValue);
export const checkIsPointerDevice = () => queryMatchMedia('(pointer: coarse)', { ssrFallbackValue: false });
export const checkIsHoverDevice = () => queryMatchMedia('(hover: hover) and (pointer: fine)', { ssrFallbackValue: false });
export const isBetween = (x, min, max) => x >= min && x <= max;
export const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
export const focusInput = (ref) => {
    const { current: el } = ref;
    if (!el) {
        return;
    }
    el.dispatchEvent(new Event('input'));
    el.focus();
};
export const blurInput = (ref) => {
    const { current: el } = ref;
    if (!el) {
        return;
    }
    document.dispatchEvent(new Event('inputauthresetfocus'));
    el.blur();
};
